import { decodeToken } from 'react-jwt';

import type {
  UserJwtDto,
  UserTokens,
} from '@ll-platform/frontend/core/auth/types';

const userTokensLsKey = 'userTokens';

export function saveUserTokens(tokens: UserTokens) {
  localStorage.setItem(userTokensLsKey, JSON.stringify(tokens));
}

export function getUserTokens() {
  const tokens = localStorage.getItem(userTokensLsKey);

  return tokens ? (JSON.parse(tokens) as UserTokens) : null;
}

export function clearUserTokens() {
  localStorage.removeItem(userTokensLsKey);
}

// NOTE: Don't use this method for authorization
// Use only if you can't wait to fetch user profile
export function getUserJwt(): UserJwtDto | null {
  const tokens = getUserTokens();
  if (!tokens?.accessToken) {
    return null;
  }

  return decodeToken(tokens.accessToken);
}
